var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 203,
    viewBox: "0 0 487 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M241.444 43.7692C226.279 51.3095 214.427 59.7788 206.335 67.4554C217.094 72.9345 233.235 78.912 253.631 83.5796C237.23 77.2458 238.672 54.4003 241.444 43.7692Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M482.021 60.4931C460.501 49.0019 439.808 40.4751 420.077 34.3924C430.01 41.826 444.433 61.411 422.667 80.2819C441.867 75.4883 461.725 69.0096 482.021 60.4931Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M241.444 43.7692C226.279 51.3095 214.427 59.7788 206.335 67.4554C217.094 72.9345 233.235 78.912 253.631 83.5796M241.444 43.7692C238.672 54.4003 237.23 77.2458 253.631 83.5796M241.444 43.7692C281.058 24.0714 343.272 10.7137 420.077 34.3924M253.631 83.5796C295.366 93.1303 354.921 97.1959 422.667 80.2819M420.077 34.3924C439.808 40.4751 460.501 49.0019 482.021 60.4931C461.725 69.0096 441.867 75.4883 422.667 80.2819M420.077 34.3924C430.01 41.826 444.433 61.411 422.667 80.2819",
    stroke: "white",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-337.836 6C-228.987 100.166 88.1486 254.664 485.905 119.325",
    stroke: "white",
    strokeWidth: 3,
    height: 1000,
    width: 1000
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.6a449e384ded62d57aa6fb9863591416.svg";
export { ForwardRef as ReactComponent };